import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Tooltip from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/Tooltip'
import { isHourlyFixedBalanceAllowance } from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'

import Accrued from './Accrued'
import Advance from './Advance'
import Carryovers from './Carryovers'
import Incidence from './Incidence'

interface Props {
  allowance: Allowance
  accrued: number
  carryOver: number
  incidence: number
  selectedCycle: Cycle
  nextCycle: Cycle | null | undefined
  advance: number
}

const BalanceTooltip = ({
  allowance,
  accrued,
  carryOver,
  incidence,
  selectedCycle,
  nextCycle,
  advance,
}: Props) => {
  const isHourlyFixedBalance = isHourlyFixedBalanceAllowance(allowance)

  return (
    <Tooltip title={i18n.t('time_off.cycle_balance')}>
      <>
        <Accrued
          amount={accrued}
          selectedCycle={selectedCycle}
          isHourlyFixedBalance={isHourlyFixedBalance}
        />
        {carryOver > 0 && accrued > carryOver && (
          <Carryovers amount={carryOver} isHourlyFixedBalance={isHourlyFixedBalance} />
        )}
        {incidence > 0 && accrued > incidence && (
          <Incidence allowanceIncidence={incidence} isHourlyFixedBalance={isHourlyFixedBalance} />
        )}
        {advance < 0 && (
          <Advance
            amount={advance}
            nextCycle={nextCycle}
            isHourlyFixedBalance={isHourlyFixedBalance}
          />
        )}
      </>
    </Tooltip>
  )
}

export default observer(BalanceTooltip)
